import { collection, addDoc, serverTimestamp, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Create a notification for managers
 * @param {string} title - Notification title
 * @param {string} message - Notification message
 * @param {string} union - Optional union filter (sends to managers in this union)
 */
export async function createManagerNotification(title, message, union = null) {
  try {
    console.log("Creating notification:", { title, message, union });
    
    // Get all users first, then filter in memory
    const allUsersSnap = await getDocs(collection(db, "users"));
    console.log(`Total users in database: ${allUsersSnap.docs.length}`);
    
    // Filter for managers and admins
    let recipients = allUsersSnap.docs.filter(doc => {
      const data = doc.data();
      const isManagerOrAdmin = data.role === "manager" || data.role === "admin";
      console.log(`User: ${data.fullName}, Role: ${data.role}, Union: ${data.union}, IsManagerOrAdmin: ${isManagerOrAdmin}`);
      return isManagerOrAdmin;
    });
    
    console.log(`Found ${recipients.length} managers/admins (before union filter)`);
    
    // If union specified, try to filter by union first
    if (union) {
      const unionRecipients = recipients.filter(doc => doc.data().union === union);
      console.log(`Found ${unionRecipients.length} managers/admins in union: ${union}`);
      
      if (unionRecipients.length > 0) {
        recipients = unionRecipients;
      } else {
        console.warn(`No managers/admins found for union: ${union}, sending to all managers/admins`);
      }
    }
    
    if (recipients.length === 0) {
      console.warn("No managers or admins found to notify");
      return;
    }
    
    // Create notification for each recipient
    const notificationPromises = recipients.map(recipientDoc => {
      const recipientData = recipientDoc.data();
      console.log(`Creating notification for: ${recipientData.fullName} (${recipientData.role})`);
      return addDoc(collection(db, "notifications"), {
        recipientId: recipientDoc.id,
        title,
        message,
        read: false,
        createdAt: serverTimestamp()
      });
    });
    
    await Promise.all(notificationPromises);
    console.log("Notifications created successfully");
  } catch (err) {
    console.error("Error creating notification:", err);
    // Don't throw, just log the error so the main flow continues
  }
}

/**
 * Create a notification for a specific coach
 * @param {string} coachId - Coach user ID
 * @param {string} title - Notification title
 * @param {string} message - Notification message
 */
export async function createCoachNotification(coachId, title, message) {
  try {
    await addDoc(collection(db, "notifications"), {
      recipientId: coachId,
      title,
      message,
      read: false,
      createdAt: serverTimestamp()
    });
    console.log("Coach notification created successfully");
  } catch (err) {
    console.error("Error creating coach notification:", err);
  }
}

/**
 * Create a notification for a specific referee
 * @param {string} refereeId - Referee user ID
 * @param {string} title - Notification title
 * @param {string} message - Notification message
 */
export async function createRefereeNotification(refereeId, title, message) {
  try {
    await addDoc(collection(db, "notifications"), {
      recipientId: refereeId,
      title,
      message,
      read: false,
      createdAt: serverTimestamp()
    });
    console.log("Referee notification created successfully");
  } catch (err) {
    console.error("Error creating referee notification:", err);
  }
}
